import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ReservesRetainedService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/ReservesRetainedprofit/';

  insertprofit(data: any) {
    debugger
    return this.http.post(this.apiUrl + 'Adding', data)
  }

  getreserveprofit(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOne?id=' + id)
  }
  getreserveprofitLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOneLY?id=' + id)
  }
}
